<template>
  <div style="margin-top: 30px">
    <div
      v-for="item in classList"
      @click="changeClass(item)"
      :class="[nowactive === item.name ? 'activeClass' : '', 'classwarp']"
      :key="item.name"
    >
      <div class="classcontent">
        <i
          style="font-size: 16px; position: relative; top: 1px"
          :class="item.icon"
        ></i>
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from "vue";

const emit = defineEmits(["changeClass"]);

const classList = [
  { icon: "iconfont icon-rizhi", name: "全部文件", value: "" },
  { icon: "iconfont icon-yasuobao", name: "压缩包", value: "compressFile" },
  { icon: "iconfont icon-anzhuangbao", name: "安装包", value: "app" },
  { icon: "iconfont icon-video", name: "视频", value: "video" },
  { icon: "iconfont icon-audio", name: "音频", value: "audio" },
  { icon: "iconfont icon-gengduo", name: "其他", value: "other" },
];

const nowactive = ref("全部文件");

function changeClass(item) {
  nowactive.value = item.name;
  emit("changeClass", item);
}
</script>

<style lang="scss" scoped>
.classwarp {
  font-size: 12px;
  line-height: 1.5;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #f1f1f1;
  }
}

.classcontent {
  display: block;
  position: relative;
  height: 45px;
  line-height: 46px;
  padding: 0 0 0 65px;
  font-size: 14px;
  text-decoration: none;
  zoom: 1;
  letter-spacing: 5px;
}

.activeClass {
  background: #ecf7fd;
  color: #3fbbff;
  font-weight: bold;
}
</style>
